import { useSnapshot } from 'app/agriculture/queries/snapshots/useSnapshot';
import { useDevice } from 'app/agriculture/queries/devices/useDevice';
import { useMemo } from 'react';
import { checkNetwork } from 'app/agriculture/routes/Devices/utils/status/networkStatus/checkNetwork';
import { StatusMessage } from 'app/agriculture/routes/Devices/utils/status/types';
import { aggregateStatusMessages } from 'app/agriculture/routes/Devices/utils/status/aggregateStatusMessages';

export function useNetworkStatus({ deviceId }: { deviceId: string }): StatusMessage {
    const device = useDevice({ deviceId });

    const networkSnapshot = useSnapshot({
        parentId: deviceId,
        snapshotType: 'Network',
        shelfLife: { hours: 1 },
    });

    return useMemo(
        () =>
            aggregateStatusMessages([
                checkNetwork({ device, snapshots: { Network: networkSnapshot } }),
            ]),
        [device, networkSnapshot],
    );
}
